export type CrumplePopPricingItem = {
    name: string,
    label: string,
    subtitle: string,
    trialFeatures: string[],
    fullFeatures: string[],
    hostOptions: string[],

}

const creatorHostOptions = [
    'Premiere Pro', 'Final Cut Pro', 'DaVinci Resolve', 'Adobe Audition',
    'Apple Logic', 'Apple GarageBand', 'Audacity'
];

const fullHostOptions = [
    ...creatorHostOptions, 'Avid Media Composer', 'Avid Pro Tools'
];

const fullFeatureOptions = [
    'Voice Enhance', 'EchoRemover', 'AudioDenoise', 'WindRemover', 'TrafficRemover', 'ClipRemover',
    'Levelmatic', 'RustleRemover', 'PopRemover', 'Photon'
]

const cpopPricingData: CrumplePopPricingItem[] = [
    {
        name: 'starter',
        label: 'Starter',
        subtitle: 'For users getting started',
        trialFeatures: ['Voice Enhance', 'EchoRemover', 'AudioDenoise', 'WindRemover', 'TrafficRemover', 'ClipRemover', 'Levelmatic', 'Photon'],
        fullFeatures: ['RustleRemover', 'PopRemover'],
        hostOptions: []
    },
    {
        name: 'creator',
        label: 'Creator',
        subtitle: 'For one host',
        trialFeatures: [],
        fullFeatures: fullFeatureOptions,
        hostOptions: creatorHostOptions
    },
    {
        name: 'pro',
        label: 'Pro',
        subtitle: 'For all supported hosts',
        trialFeatures: [],
        fullFeatures: fullFeatureOptions,
        hostOptions: fullHostOptions
    },
    {
        name: 'perpetual',
        label: 'Pro Perpetual',
        subtitle: 'Perpetual License',
        trialFeatures: [],
        fullFeatures: fullFeatureOptions,
        hostOptions: fullHostOptions
    }
]
export default cpopPricingData;
